/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Deactivate_TitleInputs */

const en_users_deactivate_title = /** @type {(inputs: Users_Deactivate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate user?`)
};

const pt_br2_users_deactivate_title = /** @type {(inputs: Users_Deactivate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar usuário?`)
};

/**
* | output |
* | --- |
* | "Deactivate user?" |
*
* @param {Users_Deactivate_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_deactivate_title = /** @type {((inputs?: Users_Deactivate_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Deactivate_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_deactivate_title(inputs)
	return pt_br2_users_deactivate_title(inputs)
});